'use client';

import { useState } from 'react';

import { Box, Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';
import { TestimonialElearning } from 'src/sections/landing/components/testimonial-elearning';

import { IntroHrm } from '../components/intro-hrm';
import { DetailHrmFunctions } from '../components/detail-hrm-functions';
import { StartWithCenterUpHrm } from '../components/start-with-center-up-hrm';

export const HrmSubPageView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Box sx={{ overflowX: 'hidden', width: 1 }}>
      <Container>
        <IntroHrm setOpenDemoForm={() => setOpenDemo(true)} />
        <CustomerElearning />
        <DetailHrmFunctions />
      </Container>
      <TestimonialElearning />
      <Container>
        <StartWithCenterUpHrm setOpenDemoForm={() => setOpenDemo(true)} />
      </Container>
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Box>
  );
};
